import React, { FC, useContext } from 'react';
import { authContext } from '../../../../store/authStore/AuthContext';
import { CustomModal } from '../../../../styles/styled';
import { ExpertiseExpertListType } from '../../../PovsExpertisePage/types';
import { ExpertiseListFeedbacks, ExpertiseListAnswers } from '../../styled';
import { ExpertiseExpertListsType } from '../../types';

type ExpertModelQuesProps = {
  currentQuestion?: ExpertiseExpertListsType;
  setOpen: (value: boolean) => void;
  open: boolean;
  povsQuestion?: ExpertiseExpertListType;
  bookAdaptive?: boolean;
  bookCartographic?: boolean;
};

export const ExpertModelQues: FC<ExpertModelQuesProps> = ({
  currentQuestion,
  setOpen,
  open,
  bookCartographic,
  bookAdaptive,
  povsQuestion,
}) => {
  const { state } = useContext(authContext);

  return (
    <>
      <CustomModal
        title=""
        centered
        visible={open}
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
        width={800}
      >
        {currentQuestion ? (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.1. Обеспечение соответствия содержания учебника и разработанных в комплекте с ним учебных пособий
              требованиям федерального государственного образовательного стандарта по формированию личностных,
              метапредметных и предметных результатов, содержанию примерных основных образовательных программ.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.textbook_body_accordance}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.textbook_body_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        ) : (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.1. В содержании учебника и разработанных в комплекте с ним учебных пособий отражены национальные
              российские ценности, региональные и этнокультурные особенности субъекта Российской Федерации, а также
              многообразие, единство национальных культур и народов России, поликультурный характер российского
              общества.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {povsQuestion?.national_values_is_present_povs}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {povsQuestion?.national_values_is_present_povscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion ? (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.2. Принадлежность учебника и разработанных в комплекте с ним учебных пособий к совокупности учебников,
              обеспечивающей преемственность изучения учебного предмета или предметной области на соответствующем уровне
              образования (далее - завершенная предметная линия учебников) (за исключением специального учебника).
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию: {!bookAdaptive ? currentQuestion?.textbook_affiliation : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {!bookAdaptive ? currentQuestion?.textbook_affiliation_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        ) : (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.2. В содержании учебника и разработанных в комплекте с ним учебных пособий представлен материал по
              истории и культурному наследию соответствующего субъекта Российской Федерации.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию: {povsQuestion?.corresponding_region_history_povs}
              </div>
              <br />
              <div className="text">
                Комментарий: <br />
                {povsQuestion?.corresponding_region_history_povscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion ? (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.3. Соответствие наименования учебника и разработанных в комплекте с ним учебных пособий наименованию
              учебного предмета или предметной области соответствующего федерального государственного образовательного
              стандарта.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.textbook_title_accordance}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.textbook_title_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        ) : (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.3. Отсутствие в содержании учебника и разработанных в комплекте с ним учебных пособий материалов,
              актуализирующих межнациональные, межэтнические конфликты, превосходство одного народа (национальности) над
              другим.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {povsQuestion?.no_national_conflict_povs}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {povsQuestion?.no_national_conflict_povscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion ? (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.4. Соответствие учебника и разработанных в комплекте с ним учебных пособий предметной концепции
              соответствующего учебного предмета или предметной области (при ее наличии).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.concept_accordance}</div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {currentQuestion?.concept_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        ) : (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.4. Языковая составляющая учебника и разработанных в комплекте с ним учебных пособий соответствует
              современному литературному языку народов Российской Федерации.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {povsQuestion?.lit_language_is_present_povs}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {povsQuestion?.lit_language_is_present_povscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion ? (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.5. Полнота представления в содержании учебника и разработанных в комплекте с ним учебных пособий научных
              теорий, составляющих основу современных научных знаний по учебному предмету.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.theoretical_fullness}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.theoretical_fullness_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        ) : (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.1. Учебник и разработанных в комплекте с ним учебных пособий рекомендован к включению в федеральный
              перечень учебников.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {povsQuestion?.recommended_povs}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {povsQuestion?.recommended_povscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.6. Использование в содержании учебника и разработанных в комплекте с ним учебных пособий понятийного
              (терминологического) аппарата, соответствующего предметной области научного знания.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.terminology_accordance}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.terminology_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.7. Наличие в учебнике и разработанных в комплекте с ним учебных пособиях сведений о передовых
              достижениях современной науки, техники и технологий, в том числе полученных и разработанных в рамках
              реализации Стратегии научно-технологического развития Российской Федерации, утвержденной Указом Президента
              Российской Федерации от 1 декабря 2016 г. N 642.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.scientific_news_is_present}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.scientific_news_is_present_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.8. Изложение материалов учебника и разработанных в комплекте с ним учебных пособий с учетом особенностей
              и направленности образовательных программ среднего профессионального образования, реализуемых на базе
              основного общего образования или интегрированных с образовательными программами основного общего и
              среднего общего образования (для учебников, обеспечивающих реализацию образовательных программ среднего
              профессионального образования, реализуемых на базе основного общего образования или интегрированных с
              образовательными программами основного общего и среднего общего образования).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.program_accordance}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.program_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.9. Структурированность, логичность и последовательность содержания учебника и разработанных в комплекте
              с ним учебных пособий в изложении предметного материала.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.logic_and_structure}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.logic_and_structure_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.10. Проработанность методического аппарата учебника и разработанных в комплекте с ним учебных пособий в
              части реализации системно-деятельностного подхода в обучении предмету, развития мотивации к учению,
              интеллектуальной, проектной и творческой деятельности обучающихся
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.methodologic_motivation}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.methodologic_motivation_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.11. Проработанность методического аппарата учебника и разработанных в комплекте с ним учебных пособий в
              части обеспечения овладения обучающимися приемами отбора, анализа, синтеза информации на определенную
              тему;
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.methodologic_analitic}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.methodologic_analitic_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.12. Проработанность методического аппарата учебника и разработанных в комплекте с ним учебных пособий в
              части формирования навыков смыслового чтения, самостоятельной учебной деятельности, применения полученных
              знаний в практической деятельности;
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.methodologic_practic}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.methodologic_practic_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.13. Проработанность методического аппарата учебника и разработанных в комплекте с ним учебных пособий в
              части формирования критического мышления, развития аргументированного представления точки зрения.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.methodologic_critic}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.methodologic_critic_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.14. Обеспечение возможности использования учебника и разработанных в комплекте с ним учебных пособий в
              групповой деятельности обучающихся, поддержке коммуникации между участниками образовательных отношений.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.group_activity}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.group_activity_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.15. Разнообразие видов текстовой информации, иллюстраций, материалов, представленных в графическом и
              табличном виде в содержании учебника и разработанных в комплекте с ним учебных пособий.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.text_img_diversity}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.text_img_diversity_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.16. Изложение материалов учебника и разработанных в комплекте с ним учебных пособий с учетом возрастных
              особенностей психофизиологического развития обучающихся.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.age_accordance}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.age_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.17. Соответствие формы подачи материалов учебника и разработанных в комплекте с ним учебных пособий
              примерным адаптированным основным образовательным программам (для специальных учебников).
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{!bookAdaptive ? ' -' : currentQuestion?.adaptive_accordance}
              </div>
              <br />
              <div className="text">
                Комментарий: {!bookAdaptive && 'критерий не применяется'}
                <br />
                {currentQuestion?.adaptive_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.18. Соответствие примера рабочей программы по учебному предмету, содержащегося в методическом пособии
              для учителя, примерной основной образовательной программе и примерной рабочей программе по учебному
              предмету (при наличии).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.example_accordance}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.example_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.19. Отсутствие в учебнике заданий, выполнение которых обязательно непосредственно в учебнике, за
              исключением электронных форм учебника.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.no_tests_in_textbook}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.no_tests_in_textbook_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.20. Отражение в учебнике и разработанных в комплекте с ним учебных пособиях вклада российских деятелей
              науки, культуры, а также выдающихся изобретателей и инженеров России в развитие научных знаний, культуры и
              технологического развития.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.russian_science_is_present}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.russian_science_is_present_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.21. Наличие в тексте учебника и разработанных в комплекте с ним учебных пособий ссылок на дополнительные
              источники информации по предмету, ориентирующих обучающихся использовать достоверные и актуальные
              источники информации.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.links_in_texetbook_is_present}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.links_in_texetbook_is_present_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              3.22. Направленность содержания учебника и разработанных в комплекте с ним учебных пособий на формирование
              у обучающихся российской гражданской идентичности, ценностных ориентиров верховенства права, поддержания
              общественной безопасности, свободы и ответственности.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.for_all_good}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.for_all_good_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.23. Правильность отображения Государственной границы Российской Федерации и территории Российской
              Федерации, территорий субъектов Российской Федерации и территорий муниципальных образований, а также
              наименований географических объектов Российской Федерации в соответствии с требованиями законодательства в
              области наименований географических объектов, а также политического устройства мира: названий государств и
              территорий, их столиц и центров, достоверности отображения государственных границ иностранных государств
              на картографическом материале, представленном в учебнике (при проведении экспертизы учебников и
              разработанных в комплекте с ними учебных пособий, содержащих картографический материал).
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию: {bookCartographic ? currentQuestion?.border_accuracy : '-'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {bookCartographic ? currentQuestion?.border_accuracy_comment : 'Критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.24. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях ошибок, в том числе
              грамматических, орфографических, пунктуационных, речевых, опечаток (в том числе применительно к
              иллюстративному материалу, комментариям, примечаниям).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.mistakes_are_missing}</div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {currentQuestion?.mistakes_are_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.25. Соответствие текста учебника и разработанных в комплекте с ним учебных пособий нормам речи и
              правилам речевого этикета языка, на котором изданы учебник и разработанные в комплекте с ним учебные
              пособия, а также отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях ненормативной
              лексики.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.textbook_lang_accordance}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.textbook_lang_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.26. Соответствие иллюстративного материала, содержащегося в учебнике и разработанных в комплекте с ним
              учебных пособиях, целям достижения образовательных результатов по образовательным программам
              соответствующего уровня общего образования и направленности.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.textbook_img_accordance}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.textbook_img_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.27. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              противоречащих (противоречащей) Конституции Российской Федерации и законодательству Российской Федерации и
              (или) оправдывающих (оправдывающей) противоправное поведение.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.criminal_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.criminal_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.28. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              направленных (направленной) на формирование неуважительного отношения к Российской Федерации, органам
              государственной власти и (или) органам местного самоуправления, народам, проживающим в Российской
              Федерации, конфессиям, социальным группам.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.impolite_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.impolite_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.29. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              побуждающих (побуждающей) детей к совершению действий, представляющих угрозу их жизни и (или) здоровью, в
              том числе к причинению вреда своему здоровью и жизни (самоубийству).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.suicide_is_missing}</div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {currentQuestion?.suicide_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.30. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              побуждающих (побуждающей) к употреблению наркотических, психотропных и (или) одурманивающих веществ,
              табака, алкогольной и спиртосодержащей продукции, а также безалкогольных тонизирующих напитков, в том
              числе энергетических.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.addiction_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.addiction_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.31. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              побуждающих (побуждающей) к асоциальному поведению и (или) образу жизни, в том числе азартным играм,
              попрошайничеству, бродяжничеству, проституции.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.asocial_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.asocial_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.32. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              обосновывающих (обосновывающей) или оправдывающих (оправдывающей) допустимость насилия и (или) жестокости
              либо побуждающих (побуждающей) осуществить насильственные действия по отношению к людям или животным.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.violence_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.violence_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.33. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях сведений (информации),
              направленных (направленной) на поддержку и (или) оправдание экстремизма и терроризма, в том числе ссылок
              на информационные материалы, содержащиеся в федеральном списке экстремистских материалов и (или) на
              доменные имена, указатели страниц сайтов в информационно-телекоммуникационной сети {'"Интернет"'} и
              сетевые адреса, позволяющие идентифицировать сайты в информационно-телекоммуникационной сети{' '}
              {'"Интернет"'}, содержащиеся в единой автоматизированной информационной системе {'"Единый'} реестр
              доменных имен, указателей страниц сайтов в сети {'"Интернет"'} и сетевых адресов, позволяющих
              идентифицировать сайты в сети
              {'"Интернет"'}, содержащие информацию, распространение которой в Российской Федерации {'запрещено"'}.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.terrorism_is_missing}</div>
              <br />
              <div className="text">
                Комментарий: <br />
                {currentQuestion?.terrorism_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.34. Отсутствие в учебнике и разработанных в комплекте с ним учебных пособиях информации, отрицающей
              семейные ценности, пропагандирующей нетрадиционные сексуальные отношения и формирующей неуважение к
              родителям и (или) другим членам семьи.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.lgbt_is_missing}</div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {currentQuestion?.lgbt_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks>
            <div className="text">
              3.35. Отсутствие в содержании (в том числе в иллюстративном материале) учебника и разработанных в
              комплекте с ним учебных пособий недостоверных, научно неподтвержденных и сфабрикованных фактов, в том
              числе о событиях и участниках Второй мировой войны.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию: {currentQuestion?.fake_is_missing}</div>
              <br />
              <div className="text">
                Комментарий:
                <br /> {currentQuestion?.fake_is_missing_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.1. Соответствие структуры и содержания цифровых копий и электронных форм учебника и разработанных в
              комплекте с ним учебных пособий друг другу.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.web_and_paper_accordance}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.web_and_paper_accordance_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.2. Корректное отображение и функционирование электронных форм учебника и разработанных в комплекте с ним
              учебных пособий с помощью программ для трех или более операционных систем, не менее двух из которых - для
              мобильных устройств.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.correct_web_os}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.correct_web_oscomment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.3. Корректное отображение и функционирование электронных форм учебника и разработанных в комплекте с ним
              учебных пособий не менее чем на двух видах электронных устройств (стационарном или персональном
              компьютере, в том числе с подключением к интерактивной доске, планшетном компьютере, и иным электронным
              устройствам вывода информации).
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.correct_web_device}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.correct_web_device_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.4. Наличие возможности создания пользователем в электронной форме учебника и разработанных в комплекте с
              ним учебных пособий заметок, закладок и перехода к ним.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.web_aliacies_is_present}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.web_aliacies_is_present_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.5. Наличие возможности определения номера страниц цифровой копии учебника, на которой расположено
              содержание текущей страницы учебника в электронной форме.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.web_page_numbers}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.web_page_numbers_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {currentQuestion && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              4.6. Наличие в электронной форме учебника и разработанных в комплекте с ним учебных пособий дидактически
              обоснованных и методически проработанных мультимедийных и интерактивных средств, активизирующих
              познавательные способности и повышающих эффективность обучения по предмету.
            </div>
            <ExpertiseListAnswers>
              <div className="text">Экспертная оценка по критерию:{currentQuestion?.web_interactive_is_present}</div>
              <br />
              <div className="text">
                Комментарий:
                <br />
                {currentQuestion?.web_interactive_is_present_comment}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              5.1. Печатная форма учебника и разработанных в комплекте с ним учебных пособий должна быть выполнена
              шрифтом Брайля.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.brile_is_present : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.brile_is_present_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              5.2. Наличие схем, таблиц, иллюстраций, выполненных в рельефно-графическом формате, которые уточняют и
              конкретизируют содержание учебника и разработанных в комплекте с ним учебных пособий и способствуют
              компенсации недостатка чувственного опыта у слепых и слабовидящих обучающихся.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.relief_is_present : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.relief_is_present_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              5.3. Наличие (за исключением учебников, предназначенных для реализации адаптированных основных
              общеобразовательных программ начального общего образования, а также в случае, когда большая часть
              информации в учебнике представлена в графической форме (учебники по предмету «Изобразительное искусство»,
              «Технология», «Физическая культура»)) электронного приложения к учебнику, которое расценивается не
              является как аналогом электронной формы учебника для данной категории обучающихся.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.application_is_present : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.application_is_present_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              6.1. Соответствие электронного приложения содержанию и структуре печатной формы учебника и разработанным в
              комплекте с ним учебным пособиям (за исключением графических объектов и связанных с ними текстовых
              пояснений, заданий и упражнений).
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:
                {bookAdaptive ? currentQuestion?.application_web_and_paper_accordance : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive
                  ? currentQuestion?.application_web_and_paper_accordance_comment
                  : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              6.2. Представление электронного приложения в плоскопечатном текстовом или звуковом формате.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.application_flat_printed : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.application_flat_printed_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              6.3. Наличие возможности воспроизведения электронного приложения при помощи тифлофлешплеера, персонального
              или планшетного компьютера под управлением программы экранного доступа, а также чтения электронного
              приложения с помощью дисплеев Брайля.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.application_tiflopleer : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.application_tiflopleer_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              6.4. Наличие в электронном приложении элементов управления, обеспечивающих быструю навигацию по документу
              (разметка по заголовкам, перекрёстные ссылки).
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:{bookAdaptive ? currentQuestion?.application_navigation_is_present : ' -'}
              </div>
              <br />
              <div className="text">
                Комментарий:
                {bookAdaptive ? currentQuestion?.application_navigation_is_present_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}

        {!state.isPovs && (
          <ExpertiseListFeedbacks border>
            <div className="text">
              6.5. Замена простых графических объектов (схем, иллюстраций), содержащихся в печатной форме учебника и
              разработанных в комплекте с ним учебных пособиях, текстовыми пояснениями или тифлокомментариями.
            </div>
            <ExpertiseListAnswers>
              <div className="text">
                Экспертная оценка по критерию:
                {bookAdaptive ? currentQuestion?.img_to_tiflo_is_present : ' -'}
              </div>
              <div className="text">
                Комментарий:{' '}
                {bookAdaptive ? currentQuestion?.img_to_tiflo_is_present_comment : ' критерий не применяется'}
              </div>
            </ExpertiseListAnswers>
          </ExpertiseListFeedbacks>
        )}
      </CustomModal>
    </>
  );
};
